"use strict";

var _toConsumableArray = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var loadCommands = function loadCommands(_ref) {
  var configService = _ref.configService,
      commandService = _ref.commandService;
  return function (next) {
    return function (args) {
      var commands = _toConsumableArray(configService.commands);

      commandService.load(commands);
      next(args);
    };
  };
};

var _default = loadCommands;
exports.default = _default;